<p class="post__list-text" v-html="htmlTextWithTargetBlank"></p>
